import { PackLoanLimitBhvEnum } from '@albatrosdeveloper/ave-models-package/lib/enums/pack-loan-limit-bhv-enum';
import { TranslationKey } from 'app/core/i18n/translation-keys';

// solo WARNING deja continuar cuando la solicitud supera el límite del cliente
export const PACK_LOAN_LIMIT_WARNING: string = PackLoanLimitBhvEnum.WARNING;

// Los valores son claves de traducción, no texto: el template las pasa por `| t` y el
// componente las resuelve con LanguageService. Guardar el texto aquí dejaba el modal en
// español aunque la pantalla estuviera migrada.
export const PACK_LOAN_MODAL_TEXTS = {
  title: 'DOCUMENT_GENERATE.PACK_LOAN_MODAL.TITLE',
  subtitle: 'DOCUMENT_GENERATE.PACK_LOAN_MODAL.SUBTITLE',
  packagingSection: 'DOCUMENT_GENERATE.PACK_LOAN_MODAL.PACKAGING_SECTION',
  containersSection: 'DOCUMENT_GENERATE.PACK_LOAN_MODAL.CONTAINERS_SECTION',
  linePrefix: 'DOCUMENT_GENERATE.PACK_LOAN_MODAL.LINE_PREFIX',
  containerSubtitle: 'DOCUMENT_GENERATE.PACK_LOAN_MODAL.CONTAINER_SUBTITLE',
  capacity: 'DOCUMENT_GENERATE.PACK_LOAN_MODAL.CAPACITY',
  mixAllowed: 'DOCUMENT_GENERATE.PACK_LOAN_MODAL.MIX_ALLOWED',
  mixNotAllowed: 'DOCUMENT_GENERATE.PACK_LOAN_MODAL.MIX_NOT_ALLOWED',
  suggested: 'DOCUMENT_GENERATE.PACK_LOAN_MODAL.SUGGESTED',
  quantity: 'DOCUMENT_GENERATE.PACK_LOAN_MODAL.QUANTITY',
  reason: 'DOCUMENT_GENERATE.PACK_LOAN_MODAL.REASON',
  note: 'DOCUMENT_GENERATE.PACK_LOAN_MODAL.NOTE',
  limit: 'DOCUMENT_GENERATE.PACK_LOAN_MODAL.LIMIT',
  consigned: 'DOCUMENT_GENERATE.PACK_LOAN_MODAL.CONSIGNED',
  accumulated: 'DOCUMENT_GENERATE.PACK_LOAN_MODAL.ACCUMULATED',
  available: 'DOCUMENT_GENERATE.PACK_LOAN_MODAL.AVAILABLE',
  freeLoan: 'DOCUMENT_GENERATE.PACK_LOAN_MODAL.FREE_LOAN',
  addRequest: 'DOCUMENT_GENERATE.PACK_LOAN_MODAL.ADD_REQUEST',
  removeRequest: 'DOCUMENT_GENERATE.PACK_LOAN_MODAL.REMOVE_REQUEST',
  reasonRequired: 'DOCUMENT_GENERATE.PACK_LOAN_MODAL.REASON_REQUIRED',
  reasonDuplicated: 'DOCUMENT_GENERATE.PACK_LOAN_MODAL.REASON_DUPLICATED',
  quantityInvalid: 'DOCUMENT_GENERATE.PACK_LOAN_MODAL.QUANTITY_INVALID',
  limitExceeded: 'DOCUMENT_GENERATE.PACK_LOAN_MODAL.LIMIT_EXCEEDED',
  limitExceededWarning: 'DOCUMENT_GENERATE.PACK_LOAN_MODAL.LIMIT_EXCEEDED_WARNING',
  emptySelection: 'DOCUMENT_GENERATE.PACK_LOAN_MODAL.EMPTY_SELECTION',
  cancel: 'GENERAL.CANCEL',
  confirm: 'DOCUMENT_GENERATE.PACK_LOAN_MODAL.CONFIRM',
} satisfies Record<string, TranslationKey>;
